import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuthentication } from '../hooks/useAuth';

type RouteProps = {
  component: React.ComponentType<any>;
  path: string;
  exact: boolean;
};

const PublicRoute = ({ component: Component, ...rest }: RouteProps) => {
  const { user, isAuthenticating } = useAuthentication();
  const isAuthenticated = user;

  return (
    <Route
      {...rest}
      render={(props) => {
        const content =
          !isAuthenticating && isAuthenticated ? <Redirect to="/" /> : <Component {...props} />;
        return content;
      }}
    />
  );
};

export default PublicRoute;
